import React from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import {toAbsoluteUrl} from '../../../_metronic/helpers'

function HomePage() {
  const floatingStyles = {
    float: {
      animation: 'float 6s ease-in-out infinite',
    },
    floatDelay1: {
      animation: 'float 8s ease-in-out infinite 1s',
    },
    floatDelay2: {
      animation: 'float 7s ease-in-out infinite 2s',
    },
    floatDelay3: {
      animation: 'float 9s ease-in-out infinite 3s',
    },
    floatDelay4: {
      animation: 'float 5s ease-in-out infinite 4s',
    },
    fadeIn: {
      animation: 'fadeIn 0.8s ease-out forwards',
    },
    fadeInDelay: {
      animation: 'fadeIn 0.8s ease-out 0.3s both',
    },
  };

  return (
    <div className="home-page min-h-screen  relative overflow-hidden">
        {/*<PageTitle>Sistema Interno</PageTitle>*/}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px) translateX(0px) rotate(0deg);
          }
          25% {
            transform: translateY(-20px) translateX(10px) rotate(90deg);
          }
          50% {
            transform: translateY(-10px) translateX(-10px) rotate(180deg);
          }
          75% {
            transform: translateY(-30px) translateX(5px) rotate(270deg);
          }
        }

        .home-page {
            top: -20px;
            overflow: hidden;
            height: 80vh !important;
            max-height: 80vh !important;
            min-height: auto;
        }

        .home-page-container {
            top: -80px;
            position: relative;
        }
      `}</style>

      {/* Floating Particles */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {/* Top area particles */}
        <div className="absolute top-16 left-12 w-8 h-8 sm:w-12 sm:h-12 lg:w-16 lg:h-16 bg-blue-400/20 rounded-full" style={floatingStyles.float}></div>
        <div className="absolute top-20 right-16 w-12 h-12 sm:w-18 sm:h-18 lg:w-24 lg:h-24 bg-blue-500/15 rounded-full" style={floatingStyles.floatDelay1}></div>
        <div className="absolute top-32 left-1/4 w-6 h-6 sm:w-10 sm:h-10 lg:w-14 lg:h-14 bg-indigo-400/25 rounded-full" style={floatingStyles.floatDelay2}></div>
        
        {/* Left side particles */}
        <div className="absolute top-1/3 left-8 w-10 h-10 sm:w-16 sm:h-16 lg:w-20 lg:h-20 bg-cyan-400/20 rounded-full" style={floatingStyles.floatDelay3}></div>
        <div className="absolute top-1/2 left-20 w-14 h-14 sm:w-20 sm:h-20 lg:w-28 lg:h-28 bg-blue-300/15 rounded-full" style={floatingStyles.float}></div>
        <div className="absolute top-2/3 left-12 w-8 h-8 sm:w-14 sm:h-14 lg:w-18 lg:h-18 bg-teal-400/20 rounded-full" style={floatingStyles.floatDelay1}></div>
        
        {/* Right side particles */}
        <div className="absolute top-1/4 right-12 w-16 h-16 sm:w-24 sm:h-24 lg:w-32 lg:h-32 bg-blue-200/12 rounded-full" style={floatingStyles.floatDelay2}></div>
        <div className="absolute top-2/5 right-8 w-6 h-6 sm:w-12 sm:h-12 lg:w-16 lg:h-16 bg-purple-400/18 rounded-full" style={floatingStyles.floatDelay4}></div>
        <div className="absolute top-3/5 right-20 w-12 h-12 sm:w-18 sm:h-18 lg:w-24 lg:h-24 bg-indigo-300/15 rounded-full" style={floatingStyles.float}></div>
        
        {/* Bottom area particles */}
        <div className="absolute bottom-20 left-16 w-20 h-20 sm:w-28 sm:h-28 lg:w-36 lg:h-36 bg-blue-100/8 rounded-full" style={floatingStyles.floatDelay3}></div>
        <div className="absolute bottom-32 right-1/4 w-10 h-10 sm:w-16 sm:h-16 lg:w-22 lg:h-22 bg-violet-400/12 rounded-full" style={floatingStyles.floatDelay1}></div>
        <div className="absolute bottom-16 left-1/3 w-8 h-8 sm:w-14 sm:h-14 lg:w-18 lg:h-18 bg-cyan-300/20 rounded-full" style={floatingStyles.floatDelay2}></div>
        
        {/* Center area - subtle background particles */}
        <div className="absolute top-1/3 left-1/2 w-24 h-24 sm:w-32 sm:h-32 lg:w-40 lg:h-40 bg-blue-50/8 rounded-full" style={floatingStyles.floatDelay4}></div>
        <div className="absolute top-2/3 right-1/2 w-28 h-28 sm:w-36 sm:h-36 lg:w-44 lg:h-44 bg-slate-100/6 rounded-full" style={floatingStyles.float}></div>
      </div>


      {/* Main Content */}
      <main className="home-page-container min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2  items-center">
          {/* Title and Description */}
          <div className="space-y-8" style={floatingStyles.fadeIn}>
            <div className="space-y-6">
              <h1 className="text-5xl font-bold text-gray-900 leading-tight">
                Seja bem-vindo ao
                <span className="block text-blue-600">Sistema Interno</span>
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed max-w-lg">
                Seu portal centralizado para gestão administrativa. Acesse ferramentas, 
                relatórios e recursos de forma segura e eficiente.
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="relative" style={floatingStyles.fadeInDelay}>
            <div className="relative z-10">
              <img
                src={toAbsoluteUrl('/media/logos/logo-wide.png')}
                alt="Logo do Sistema Interno"
                className="rounded-2xl w-full h-50 object-cover"
              />
              <div className="absolute inset-0 rounded-2xl"></div>
            </div>
            
            {/* Floating Elements */}
            <div className="absolute -top-6 -right-6 w-20 h-20 bg-blue-600 rounded-full opacity-20 animate-pulse"></div>
            <div className="absolute -bottom-6 -left-6 w-16 h-16 bg-green-500 rounded-full opacity-20 animate-pulse delay-1000"></div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default HomePage;